<template>
  <div>
    <page-header :title="title" :container-class="containerClass" info-text="List of all registered students." />
    <div class="page-section">
      <div :class="containerClass">
        <div class="card mb-0">
          <div class="card-header">
            <div class="row align-items-center" style="white-space: nowrap">
              <!-- Search -->

              <div class="col-lg-auto">
                <form class="search-form search-form--light d-lg-inline-flex mb-8pt mb-lg-0" @submit.prevent="">
                  <b-form-input
                    class="w-lg-auto"
                    :placeholder="$t('studentMsgs.searchStudents')"
                    v-model="searchTerm"
                    @input="onSearch"
                  />
                  <b-btn variant="flush" type="submit">
                    <md-icon v-text="'search'" />
                  </b-btn>
                </form>
                <b-btn
                  v-if="!isTabSmallScreen && !showFilters"
                  variant="secondary"
                  @click.prevent="updateShowFilters(true)"
                  :class="isTabSmallScreen ? 'mb-1' : 'ml-2'"
                  size="sm"
                >
                  <i class="fas fa-sliders-h mr-1" />Show {{ !areFiltersApplied ? 'Filters' : '' }}
                </b-btn>
                <b-btn
                  variant="light"
                  class="ml-2"
                  @click.prevent="updateShowFilters(false)"
                  v-if="!isTabSmallScreen && showFilters"
                  size="sm"
                >
                  <i class="fas fa-eye-slash mr-1" />Hide {{ !areFiltersApplied ? 'Filters' : '' }}
                </b-btn>
                <b-btn
                  variant="light"
                  class="ml-2"
                  @click.prevent="clearFilters"
                  v-if="!isTabSmallScreen && areFiltersApplied"
                  size="sm"
                >
                  <i class="fas fa-times mr-1" />Clear
                </b-btn>
              </div>

              <!-- Filters and Add Btn -->
              <div class="col-lg d-flex flex-wrap justify-content-end">
                <div class="col-lg-7 px-0" :class="isTabSmallScreen ? 'mt-2 mb-2' : 'mx-0'">
                  <v-select
                    id="program"
                    class="form-control v-select-custom"
                    label="title"
                    :value="program"
                    :reduce="program => program.id"
                    placeholder="Select Program"
                    :options="allPrograms"
                    :loading="areProgramsLoading"
                    @input="onFilterApplied"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                    </template>

                    <template slot="option" slot-scope="option">
                      <div class="d-flex align-items-center">
                        <fmv-avatar :title="true" title-class="bg-transparent" rounded no-link slot="aside" size="xs">
                          <b-img :src="option.image" class="img-fluid" width="20" alt="Logo" v-if="option.image" />
                          <md-icon v-else>local_library</md-icon>
                        </fmv-avatar>
                        <span>{{ option.title }}</span>
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      {{ truncate(option.title, { length: 20 }) }}
                    </template>
                  </v-select>
                </div>
                <!-- TODO: Add filters here. (if needed) -->
                <!-- <b-dropdown class="ml-lg-auto" :text="$t('All Topics')" variant="link text-black-70" right>
                  <b-dropdown-item active>All Topics</b-dropdown-item>
                  <b-dropdown-item>My Topics</b-dropdown-item>
                </b-dropdown>

                <b-dropdown class="mr-8pt" :text="$t('Newest')" variant="link text-black-70" right>
                  <b-dropdown-item active>Newest</b-dropdown-item>
                  <b-dropdown-item>Unanswered</b-dropdown-item>
                </b-dropdown> -->
                <!--
                <b-btn :to="{ name: 'add-student' }" exact variant="primary" v-text="$t('studentMsgs.addStudent')" /> -->
              </div>

              <div v-if="isTabSmallScreen" :style="{ marginLeft: '13px' }">
                <b-btn
                  variant="secondary"
                  @click.prevent="updateShowFilters(true)"
                  class="mb-1"
                  v-if="!showFilters"
                  size="sm"
                >
                  <i class="fas fa-sliders-h mr-1" />Show {{ !areFiltersApplied ? 'Filters' : '' }}
                </b-btn>
                <b-btn variant="light" @click.prevent="updateShowFilters(false)" v-if="showFilters" size="sm">
                  <i class="fas fa-eye-slash mr-1" />Hide {{ !areFiltersApplied ? 'Filters' : '' }}
                </b-btn>
                <b-btn variant="light" class="ml-2" @click.prevent="clearFilters" v-if="areFiltersApplied" size="sm">
                  <i class="fas fa-times mr-1" />Clear
                </b-btn>
              </div>
            </div>
          </div>
          <transition name="slide">
            <div v-if="showFilters" class="mt-2 ml-3">
              <div class="row mb-2 mx-0 w-100 mt-2">
                <div class="col-sm-4 col-md-4 mb-2 px-1" :style="isTabSmallScreen ? { marginRight: '11px' } : ''">
                  <v-select
                    label="id"
                    :options="allLocations"
                    class="form-control v-select-custom"
                    :value="location"
                    :reduce="lc => lc.id"
                    placeholder="Select Location"
                    :loading="areLocationsLoading"
                    @input="filterLocations"
                    :filter-by="filterByLocation"
                  >
                    <template slot="option" slot-scope="option"> {{ get(option, 'city') }} </template>
                    <template slot="selected-option" slot-scope="option"> {{ get(option, 'city') }} </template>
                  </v-select>
                </div>
                <div v-if="!isTabSmallScreen" class="d-flex flex-wrap justify-content-end col-lg mr-1">
                  <div class="col-lg-7 px-0 mx-0">
                    <date-picker
                      v-model="dateRange"
                      format="MMMM DD, YYYY"
                      valueType="YYYY-MM-DD"
                      style="width: 100%"
                      id="date"
                      lang="en"
                      placeholder="Filter by Start Date Range"
                      range
                      @input="filterByDateRange"
                    ></date-picker>
                  </div>
                </div>
                <div v-else class="col-lg-7 px-0 mt-2 mb-2 ml-1 w-full" style="margin-right: 15px;">
                  <date-picker
                    class="filter-datepicker"
                    v-model="dateRange"
                    format="MMMM DD, YYYY"
                    valueType="YYYY-MM-DD"
                    style="width: 100%"
                    id="dateRange"
                    lang="en"
                    placeholder="Filter by Start Date Range"
                    range
                    @input="filterByDateRange"
                  ></date-picker>
                </div>
              </div>
            </div>
          </transition>
          <!-- Students Table -->
          <b-table
            :fields="tableColumns"
            :items="students"
            :busy="isLoading"
            head-variant="light"
            class="table-nowrap"
            hover
            responsive
            no-local-sorting
            @row-clicked="onRowClicked"
            @sort-changed="onSortChange"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(avatar)="data">
              <user-avatar slot="aside" size="md" rounded="false" :user="data.item.user"> </user-avatar>
            </template>

            <template #cell(name)="data"
              ><strong> {{ data.item.user.first_name }} {{ data.item.user.last_name }} </strong></template
            >

            <template #cell(address)="data">
              {{ data.item.address }}, {{ data.item.zipcode }}, {{ data.item.city }}, {{ data.item.state }},
              {{ data.item.country }}
            </template>

            <!-- <template #cell(status)="data">
              <b-badge :class="'border border-' + fetchStudentStatus(data.item).class" variant="none">{{
                fetchStudentStatus(data.item).text
              }}</b-badge>
            </template> -->

            <template #head(actions)="">
              <span></span>
            </template>

            <template #cell(actions)="data">
              <a :href="`mailto:${data.item.user.email}`"
                ><i class="material-icons mr-1" v-b-popover.hover.left title="Email student">email</i></a
              >
              <a class="ml-2" :href="`tel:${data.item.user.phone}`" v-b-popover.hover.left title="Call student"
                ><i class="material-icons mr-1">phone</i></a
              >
            </template>
          </b-table>

          <!-- Footer Pagination -->
          <div class="card-footer">
            <pagination
              v-model="currentPage"
              :total-rows="totalStudents"
              :per-page="perPage"
              @change="onPageChange"
              aria-controls="students-table"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/Ui/PageHeader.vue';
import { debounce } from 'lodash';
import { mapActions } from 'vuex';
import { get, truncate } from 'lodash';
import Page from '@/components/Page.vue';
import Pagination from '../../../components/Ui/Pagination.vue';
import MdIcon from '../../../components/Ui/MdIcon.vue';
import { DEFAULT_PAGE_SIZE } from '../../../common/constants';
import vSelect from 'vue-select';
import UserAvatar from '../../../components/User/UserAvatar.vue';
import { FmvAvatar } from 'fmv-avatar';
import DatePicker from 'vue2-datepicker';

export default {
  components: { MdIcon, PageHeader, Pagination, UserAvatar, vSelect, FmvAvatar, DatePicker },
  extends: Page,

  data() {
    return {
      title: this.$t('studentMsgs.manageStudents'),
      showFilters: false,

      isLoading: false,
      perPage: DEFAULT_PAGE_SIZE,
      currentPage: 1,
      totalStudents: 0,
      students: [],
      searchTerm: '',
      program: null,
      location: null,
      areProgramsLoading: false,
      areLocationsLoading: false,
      allPrograms: [],
      allLocations: [],
      dateRange: [],
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: this.$t('studentMsgs.students'), active: true },
      ];
    },
    isTabSmallScreen() {
      return this.windowWidth <= 767;
    },
    areFiltersApplied() {
      return this.program || this.location || this.dateRange.length;
    },

    tableColumns() {
      return [
        { key: 'avatar', label: '' },
        { key: 'name', label: this.$t('studentMsgs.name'), tdClass: 'clickable-item' },

        { key: 'user.email', label: this.$t('authMsgs.email'), tdClass: 'clickable-item' },
        { key: 'user.phone', label: this.$t('studentMsgs.phone'), tdClass: 'clickable-item' },

        {
          key: 'actions',
          tdClass: 'text-right',
          thStyle: { minWidth: '100px' },
        },
      ];
    },
  },

  methods: {
    get,
    truncate,
    ...mapActions('program', ['getAllPrograms']),
    ...mapActions('location', ['getAllLocations']),
    ...mapActions('student', ['getAllStudents']),
    onRowClicked(data) {
      this.$router.push({
        name: 'schl-student-profile',
        params: { id: data.id },
      });
    },
    filtersApplied() {
      this.$router.replace({
        name: 'schl-students-list',
        query: {
          ...(this.program && { program: this.program }),
          ...(this.location && { location: this.location }),
          ...(!!this.dateRange.length &&
            this.dateRange[0] &&
            this.dateRange[1] && { start_date: this.dateRange[0] + ',' + this.dateRange[1] }),
        },
      });
    },
    async fetchStudents(pageNum = 1, params = {}) {
      this.isLoading = true;
      document.getElementById('app').scrollIntoView();
      const response = await this.getAllStudents({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...(this.ordering && { ordering: this.ordering }),
        ...(this.searchTerm && { search: this.searchTerm }),
        ...(this.program && { prg_id: this.program }),
        ...(this.location && { location: this.location }),
        ...(!!this.dateRange.length &&
          this.dateRange[0] &&
          this.dateRange[1] && { start_date: this.dateRange[0] + ',' + this.dateRange[1] }),
        ...params,
      });
      this.students = response.data.results;
      this.currentPage = pageNum;
      this.totalStudents = response.data.count;
      this.isLoading = false;
    },
    async fetchPrograms() {
      this.areProgramsLoading = true;
      const response = await this.getAllPrograms({});
      this.allPrograms = response.data;

      this.areProgramsLoading = false;
    },
    onPageChange(pageNum) {
      this.fetchStudents(pageNum);
    },
    clearFilters() {
      this.searchTerm = '';
      this.program = this.location = null;
      this.dateRange = [];
      this.filtersApplied();
      this.fetchStudents();
    },
    updateShowFilters(value) {
      this.showFilters = value;
    },
    onSortChange(context) {
      this.ordering = context.sortDesc ? '-' + context.sortBy : context.sortBy;
      this.fetchStudents();
    },
    onFilterApplied(value) {
      this.program = value;
      this.filter();
    },
    filterByLocation(option, label, search) {
      let searchLower = search.toLowerCase();
      this.location = option;
      return (
        get(option, 'address', '')
          .toLowerCase()
          .indexOf(searchLower) > -1 ||
        get(option, 'city', '')
          .toLowerCase()
          .indexOf(searchLower) > -1 ||
        get(option, 'state', '')
          .toLowerCase()
          .indexOf(searchLower) > -1 ||
        get(option, 'zipcode', '')
          .toLowerCase()
          .indexOf(searchLower) > -1 ||
        get(option, 'country', '')
          .toLowerCase()
          .indexOf(searchLower) > -1
      );
    },
    filter() {
      this.filtersApplied();
      this.fetchStudents();
    },
    filterLocations(value) {
      this.location = value;
      this.filter();
    },
    filterByDateRange(value) {
      this.dateRange = value;
      this.filter();
    },
    async fetchLocation() {
      this.areLocationsLoading = true;

      const response = await this.getAllLocations({});
      this.allLocations = response.data;
      this.areLocationsLoading = false;
    },
    onSearch() {
      this.debouncedSearchStudents(this);
    },

    debouncedSearchStudents: debounce(vm => {
      vm.fetchStudents();
    }, 500),
  },

  async mounted() {
    this.fetchLocation();
    this.fetchPrograms();
    if (this.$route.query.program) {
      this.program = Number(this.$route.query.program);
    }
    if (this.$route.query.location) {
      this.location = Number(this.$route.query.location);
      this.showFilters = true;
    }
    if (this.$route.query.start_date) {
      const date = this.$route.query.start_date.split(',');
      this.dateRange = [date[0], date[1]];
      this.showFilters = true;
    }
    this.fetchStudents();
  },
};
</script>
